import { environment } from '@env/environment';

import { PixelResource } from '@infra/pixel';
import { QueryParamsResource } from '@infra/query-params';

import { GoogleTagManagerService } from 'angular-google-tag-manager';

import { sha256 } from '@shared/utils/sha256';
import { EventTrackerAdapter } from '../event-tracker.adapter';

export class GoogleTagManagerAdapter implements EventTrackerAdapter {
  constructor(
    private queryParamsResource: QueryParamsResource,
    private gtmResource: GoogleTagManagerService,
    private pixelResource: PixelResource,
  ) {}

  track<T extends Partial<T>>(eventName: string, eventData?: T): void {
    const qa_mode = this.queryParamsResource.getCurrent()['qa_mode'];

    if (environment.test !== 'prod' || qa_mode) {
      return;
    }

    if (!eventData) {
      this.gtmResource.pushTag({ event: eventName, data: undefined });
      return;
    }

    this.facebookConversion(eventData as never).then(data => {
      this.gtmResource.pushTag({
        event: eventName,
        data,
      });
    });
  }

  private async facebookConversion(payload: Record<string, unknown>) {
    const fbc = this.pixelResource.getFacebookClick();
    const fbp = this.pixelResource.getFacebookPixel();

    const eventPayload = { ...payload };

    const toHash = eventPayload?.['email'] as string;

    if (eventPayload?.['phone']) {
      eventPayload['phone'] = '55' + String(eventPayload['phone']).replace(/[\(\)\-\s]/g, '');
    }

    const hashedId = toHash ? await sha256(toHash) : undefined;

    let facebookPayload = {
      em: eventPayload?.['email'],
      fn: eventPayload?.['name'] ? String(eventPayload['name']).split(' ')[0] : null,
      ln: eventPayload?.['name'] ? String(eventPayload['name']).split(' ').slice(1).join(' ') : null,
      ph: eventPayload?.['phone'],
      ct: eventPayload?.['city'],
      st: eventPayload?.['state'],
      zp: eventPayload?.['postal_code'],
      country: 'br',
      extern_id: hashedId,
      external_id: hashedId,
      client_user_agent: navigator.userAgent,
      fbp,
      fbc,
    };

    // remove the undefined keys
    Object.keys(facebookPayload).forEach(key => {
      const value = facebookPayload[key as keyof typeof facebookPayload];

      if (value == null || value == 'undefined') {
        delete facebookPayload[key as keyof typeof facebookPayload];
      }
    });

    return facebookPayload;
  }
}
